import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

type AgreementType = 'swiss' | 'uk' | 'passive';
@Component({
  selector: 'app-rating-agreement-modal',
  templateUrl: './rating-agreement-modal.component.html',
  styleUrls: ['./rating-agreement-modal.component.scss'],
  standalone: false,
})
export class RatingAgreementModalComponent {
  @Input() type: AgreementType = 'swiss';
  accepted = false;
  constructor(private modalController: ModalController) { }

  get titleKey() {
    return 'window_energy_ratings';
  }

  get textKey() {
    if (this.type === 'swiss') return 'WER_SWISS_AGREEMENT_TEXT';
    if (this.type === 'uk') return 'WER_UK_AGREEMENT_TEXT';
    return 'PASSIVE_HOUSE_AGREEMENT_TEXT';
  }

  get checkboxKey() {
    if (this.type === 'swiss') return 'WER_SWISS_AGREEMENT_CHECKBOX';
    if (this.type === 'uk') return 'WER_UK_AGREEMENT_CHECKBOX';
    return 'PASSIVE_HOUSE_AGREEMENT_CHECKBOX';
  }

  toggleAccepted() {
    this.accepted = !this.accepted;
  }

  async continue() {
    if (!this.accepted) return;
    await this.modalController.dismiss({ accepted: true }, 'confirm');
  }
}